import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Globe, ChevronDown } from 'lucide-react';

// "America/New_York" -> "New York". Keeps the pill narrow; the full zone name
// still shows in the dropdown options.
export function shortTimezone(tz) {
  if (!tz) return '—';
  const parts = String(tz).split('/');
  return parts[parts.length - 1].replace(/_/g, ' ');
}

// Builds the picker's options in the order Timesheets uses them: the viewer's
// own zone first, then the member being viewed, then the workspace. Duplicates
// are dropped so a member in the workspace zone doesn't get two entries.
export function buildTimezoneOptions({ user, workspaceMember, activeWorkspace }) {
  const opts = [];
  const seen = new Set();
  const memberFirstName = workspaceMember?.user?.firstName || '';
  if (user?.timezone) {
    opts.push({ value: user.timezone, label: `Your timezone (${user.timezone})` });
    seen.add(user.timezone);
  }
  if (workspaceMember?.user?.timezone && !seen.has(workspaceMember.user.timezone)) {
    opts.push({
      value: workspaceMember.user.timezone,
      label: `${memberFirstName}'s Timezone (${workspaceMember.user.timezone})`,
    });
    seen.add(workspaceMember.user.timezone);
  }
  if (activeWorkspace?.timezone && !seen.has(activeWorkspace.timezone)) {
    opts.push({
      value: activeWorkspace.timezone,
      label: `${activeWorkspace.name} (${activeWorkspace.timezone})`,
    });
  }
  return opts;
}

const PILL_CLASS = 'relative inline-flex items-center gap-2 h-10 px-3 rounded-[8px] '
  + 'bg-white text-ink-900 transition';

function PillTimezoneSelect({
  value, onChange, options, disabled,
}) {
  return (
    <span
      className={`${PILL_CLASS} ${disabled ? '' : 'hover:border-brand-500'}`}
      style={{ border: '1px solid #e0e1e6' }}
    >
      <Globe size={14} className="flex-shrink-0" style={{ color: '#3d5a8a' }} />
      <span style={{ fontSize: '14px', fontWeight: 500 }} className="whitespace-nowrap">
        {shortTimezone(value)}
      </span>
      <ChevronDown size={12} className="flex-shrink-0 text-ink-500" />
      <select
        value={value}
        disabled={disabled}
        onChange={onChange}
        aria-label="Timezone"
        className="absolute inset-0 opacity-0 cursor-pointer"
        style={{ width: '100%', height: '100%' }}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
    </span>
  );
}

PillTimezoneSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  disabled: PropTypes.bool,
};

export default PillTimezoneSelect;
